import Support from "../components/support/supportSection";
import Footer from "../components/Footer/Footer";
export default function SupportPage() {
  return (
    <>
      <Support />
      <Footer />
    </>
  );
}